import { createPrefixedSelector, withBase } from "./helpers";

const baseSelectors = {
    modal: ".product-discovery-modal > .lux-inner",
    countdown: ".countdown",
    verticalSwiper: ".swiper-slide-active > .swiper-pdq-vertical",
    arrow: ".arrow",
};

const prefixModal = createPrefixedSelector(baseSelectors.modal);
const prefixCountdown = createPrefixedSelector(baseSelectors.countdown);

const PDQ = {
    values: {
        TRANSLATE_THRESHOLD_UP: -50,
        TRANSLATE_THRESHOLD_DOWN: 50,
        ACTION_DELAY: 1500,
    },
    modal: baseSelectors.modal,
    modalId: "lux-modal-product-discovery",
    modalButton: `[data-toggle="lux-popup"][data-target="lux-modal-product-discovery"]`,
    swiperWrapper: ".swiper-pdq .swiper-wrapper",
    introductorySlide: "first-slide", // no prefix
    introductorySlideOverlay: "overlay", // no prefix
    firstIntroductorySlide: ".swiper-slide.introductory-slide.campaign-slide",
    secondIntroductorySlide:
        ".swiper-slide.introductory-slide.navigation-slide",
    activeOuterSlide: ".product-slide.outer-slide.swiper-slide-active",
    luxPriceMember:
        ".product-slide .inner-slide .lux-product-card .lux-content .lux-price-member",
    itemWrap: ".lux-product-item",
    dataProdId: "data-prodid",
    countdown: {
        days: prefixCountdown("#days"),
        hours: prefixCountdown("#hours"),
        minutes: prefixCountdown("#minutes"),
        seconds: prefixCountdown("#seconds"),
    },
    arrow: withBase({
        base: ".arrow",
        up: ".up",
        down: ".down",
    }),
    slider: {
        inner: ".inner-slide",
        outer: ".outer-slide",
    },
};

export default PDQ;
